import React from "react";
import { Skeleton } from "antd";

import styled from "styled-components/macro";

const SkeletonItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  * {
    margin: 0 !important;
  }
  animation: fadeIn 0.5s ease;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const CardsSkeleton = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  .skeleton-card .ant-skeleton-title {
    height: 155px;
  }
`;

const SkeletonCard = styled.article`
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  transition: 0.3s ease;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 25px;
`;

const SkeletonTitle = styled(SkeletonItem)`
  margin: 10px auto;
`;

const SkeletonAction = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 10px 0;
  .ant-skeleton-header {
    padding-right: 0;
  }
`;

const SkeletonOpportunities = () => {
  return (
    <CardsSkeleton>
      <SkeletonCard>
        <SkeletonItem>
          <Skeleton
            className="skeleton-card"
            active
            avatar={false}
            title={{ width: 262, rows: 1 }}
            paragraph={false}
          />
        </SkeletonItem>
        <SkeletonTitle>
          <Skeleton
            active
            avatar={false}
            title={{ width: 100, rows: 1 }}
            paragraph={false}
          />
        </SkeletonTitle>
        <SkeletonAction>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
        </SkeletonAction>
      </SkeletonCard>
      <SkeletonCard>
        <SkeletonItem>
          <Skeleton
            className="skeleton-card"
            active
            avatar={false}
            title={{ width: 262, rows: 1 }}
            paragraph={false}
          />
        </SkeletonItem>
        <SkeletonTitle>
          <Skeleton
            active
            avatar={false}
            title={{ width: 100, rows: 1 }}
            paragraph={false}
          />
        </SkeletonTitle>
        <SkeletonAction>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
        </SkeletonAction>
      </SkeletonCard>
      <SkeletonCard>
        <SkeletonItem>
          <Skeleton
            className="skeleton-card"
            active
            avatar={false}
            title={{ width: 262, rows: 1 }}
            paragraph={false}
          />
        </SkeletonItem>
        <SkeletonTitle>
          <Skeleton
            active
            avatar={false}
            title={{ width: 100, rows: 1 }}
            paragraph={false}
          />
        </SkeletonTitle>
        <SkeletonAction>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
        </SkeletonAction>
      </SkeletonCard>
      <SkeletonCard>
        <SkeletonItem>
          <Skeleton
            className="skeleton-card"
            active
            avatar={false}
            title={{ width: 262, rows: 1 }}
            paragraph={false}
          />
        </SkeletonItem>
        <SkeletonTitle>
          <Skeleton
            active
            avatar={false}
            title={{ width: 100, rows: 1 }}
            paragraph={false}
          />
        </SkeletonTitle>
        <SkeletonAction>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={false}
              paragraph={false}
            />
          </SkeletonItem>
        </SkeletonAction>
      </SkeletonCard>
    </CardsSkeleton>
  );
};

export default SkeletonOpportunities;
